// `contextType` as /v1/contexts sends it. Verified against the live stag response, which is also where
// the fourth value came from: `Customer` and `CustomerOfVisma` are a deliberate distinction, not a
// backend slip - `CustomerOfVisma` is a direct Visma customer (the account holds Subscriber_
// Administrator there), while `Customer` is a customer provisioned under a distributor through Kalmar
// (the account holds only Administrator, and lands on provisioning or onboarding). The navbar shows
// both under the same group, because to the person picking a context they are both customers.
//
// Both backends send it. That is worth stating because they are two: /v1/contexts is served by
// provisioning on localhost, int and stag - which is what "the live stag response" above means - and
// by access-management on prod. The field is on the prod response as well (confirmed 2026-09-23), so
// `NavbarService.getContextGroup`, which filters on nothing else, groups the switcher there too.
//
// Kept separate from ENTITY_TYPE even though three of the spellings match: that one names the kind of
// entity a screen is showing, this one names how a context is classified. Equal strings, different
// questions - collapsing them would tie two contracts together that can move apart.
export const CONTEXT_TYPE = {
    company: 'Company',
    customerOfVisma: 'CustomerOfVisma',
    customer: 'Customer',
    distributor: 'Distributor'
}
